<template>
  <div>
    <button
      :title="data_title"
      class="bg-gray-100 border text-confirm_green text-sm px-2 h-8 leading-8 mx-2 rounded border-confirm_green hover:bg-confirm_green_hover hover:text-white focus:outline-none transition-all duration-300 ease-in-out"
    >
      {{ data_name }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'EditButton',
  props: {
    title: {
      type: String,
    },
    name: {
      type: String,
    },
  },
  data: function () {
    return {
      data_title: this.$t('edit'),
      data_name: this.$t('edit'),
    };
  },
  mounted: function () {
    this.setData();
  },
  methods: {
    setData: function () {
      if (this.title !== undefined && this.title !== null) this.data_title = this.title;
      if (this.name !== undefined && this.name !== null) this.data_name = this.name;
    },
  },
};
</script>

<style scoped></style>
